import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { ProblemModel } from './model';

export const problemAdapter: EntityAdapter<ProblemModel> = createEntityAdapter<ProblemModel>({
  selectId: model => model.id,
});

export interface ProblemState extends EntityState<ProblemModel> {
  selected: ProblemModel;
  isLoading?: boolean;
  error?: any;
}

export const initialState: ProblemState = problemAdapter.getInitialState({
  selected: null,
  isLoading: false,
  error: null,
});
